const menuCategorySections = [
  {
    title: "APPETIZERS",
    category: "APPETIZERS",
    image: "/assets/menu/appetizers.jpg",
    itemDesc: "Chips & Salsa",
    descriptionBackground: "./assets/menu/item-description-bg-red.png",
    color: "#7b1609"
  },
  {
    title: "BURRITOS",
    category: "BURRITOS",
    image: "/assets/menu/burritos.jpg",
    itemDesc: "Carne Asada Burrito",
    descriptionBackground: "./assets/menu/item-description-bg-teal.png",
    color: "#134048"
  },
  {
    title: "COMBOS",
    category: "COMBOS",
    image: "/assets/menu/combos.jpg",
    itemDesc: "Hard Shell Taco & Enchilada Combo",
    descriptionBackground: "./assets/menu/item-description-bg-yellow.png",
    color: "#ad870e"
  },
  {
    title: "DESSERTS",
    category: "DESSERTS",
    image: "/assets/menu/desserts.jpg",
    itemDesc: "Fried Ice Cream",
    descriptionBackground: "./assets/menu/item-description-bg-green.png",
    color: "#384500"
  },
  {
    title: "FAJITAS",
    category: "FAJITAS",
    image: "/assets/menu/fajitas.jpg",
    itemDesc: "Ultimate Fajitas",
    descriptionBackground: "./assets/menu/item-description-bg-red.png",
    color: "#7b1609"
  },
  {
    title: "FAVORITES",
    category: "FAVORITES",
    image: "/assets/menu/favorites.jpg",
    itemDesc: "Chile Relleno",
    descriptionBackground: "./assets/menu/item-description-bg-teal.png",
    color: "#134048"
  },
  {
    title: "KIDS",
    category: "KIDS",
    image: "/assets/menu/kids.jpg",
    itemDesc: "Kids Tacos",
    descriptionBackground: "./assets/menu/item-description-bg-yellow.png",
    color: "#ad870e"
  },
  {
    title: "SALADS, TOSTADAS & SOUPS",
    category: "SALADS",
    image: "/assets/menu/salads.jpg",
    itemDesc: "Salmon Salad",
    descriptionBackground: "./assets/menu/item-description-bg-green.png",
    color: "#384500"
  },
  {
    title: "SPECIALTIES",
    category: "SPECIALTIES",
    image: "/assets/menu/specialties.jpg",
    itemDesc: "Carne Asada Y Camarones",
    descriptionBackground: "./assets/menu/item-description-bg-red.png",
    color: "#7b1609"
  },
  {
    title: "TACOS",
    category: "TACOS",
    image: "/assets/menu/tacos.jpg",
    itemDesc: "Steak Tacos",
    descriptionBackground: "./assets/menu/item-description-bg-teal.png",
    color: "#134048"
  },

  {
    title: "BEVERAGES",
    category: "BEVERAGES",
    image: "/assets/menu/beverages.jpg",
    itemDesc: "Adios Amigos",
    descriptionBackground: "./assets/menu/item-description-bg-green.png",
    color: "#384500"
  },

  // EVERYTHING BELOW WE ARENT USING ( MIGHT USE IN THE FUTURE )

  {
    title: "BRUNCH",
    category: "BRUNCH",
    image: "/assets/menu/brunch.jpg",
    itemDesc: "Some Item",
    subTitle: "Available Sundays: 10:00am - 2:00pm"
  },
  {
    title: "A LA CARTE",
    category: "A LA CARTE",
    image: "/assets/menu/a-la-carte.jpg",
    itemDesc: "Burrito Dorado",
    descriptionBackground: "./assets/menu/item-description-bg-green.png",
    color: "#384500"
  },
  {
    title: "LUNCH SPECIALS",
    category: "LUNCH SPECIALS",
    image: "/assets/menu/lunch-specials.jpg",
    itemDesc: "Two Tacos",
    subTitle: "Available Weekdays 11:00am - 4:00pm",
    descriptionBackground: "./assets/menu/item-description-bg-yellow.png",
    color: "#ad870e"
  },
  {
    title: "SIDES",
    category: "SIDES",
    image: "/assets/menu/sides.jpg",
    itemDesc: "Refried Beans, Guacamole & Sour Cream",
    descriptionBackground: "./assets/menu/item-description-bg-green.png",
    color: "#384500"
  },
  {
    title: "FIESTA MENU",
    category: "FIESTA MENU",
    image: "/assets/menu/fiesta-menu.jpg",
    itemDesc: "Chicken Tortilla Soup"
  },
  // FOR THE TESTING APP
  {
    title: "Entree",
    category: "Entree",
    image: "/assets/menu/entree.jpg",
    itemDesc: "Chile Relleno"
  },
  {
    title: "Appetizer",
    category: "Appetizer",
    image: "/assets/menu/appetizers.jpg",
    itemDesc: "Chips & Salsa"
  }
];

export default menuCategorySections;



// WEBPACK FOOTER //
// ./src/app/menu/category-data/category-data.ts